module.exports = __webpack_public_path__ + "static/media/ong.d7671a88.png";